export default "/small-shell-logo.bf30c01e5b0b479ca794ce6b640c5f8d.svg";